import ProductionFacility from "../Models/ProductionFacility";
import MakeRequest from "../Utilities/MakeRequest";

export function getProductionFacility(productionFacilityId: string): Promise<ProductionFacility> {
	return new Promise<ProductionFacility>((resolve, reject) => {
		new MakeRequest(`/api/ProductionFacility/Get?id=${productionFacilityId}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function getProductionFacilityNames(productionFacilityIds: string[]): Promise<Map<string, string>> {
	return new Promise<Map<string, string>>((resolve, reject) => {
		new MakeRequest(`/api/ProductionFacility/GetNames?ids=${productionFacilityIds.join('&ids=')}`, "get")
			.send()
			.then((response: string) => {
				const parsed = JSON.parse(response);
				resolve(new Map(Object.entries(parsed)));
			}, reject);
	})
}
